/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for DashboardResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetDashboardTodoStatsResponse, GetDashboardTimesheetStatsResponse, GetDashboardInvoicingStatsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class DashboardResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getDashboardTodoStats(resourceOptions: HttpResourceOptions<GetDashboardTodoStatsResponse, unknown> & { defaultValue: NoInfer<GetDashboardTodoStatsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDashboardTodoStatsResponse>;
    getDashboardTodoStats(resourceOptions?: HttpResourceOptions<GetDashboardTodoStatsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDashboardTodoStatsResponse | undefined>;
    getDashboardTodoStats(resourceOptions?: HttpResourceOptions<GetDashboardTodoStatsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDashboardTodoStatsResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Dashboard/todo-stats`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getDashboardTimesheetStats(resourceOptions: HttpResourceOptions<GetDashboardTimesheetStatsResponse, unknown> & { defaultValue: NoInfer<GetDashboardTimesheetStatsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDashboardTimesheetStatsResponse>;
    getDashboardTimesheetStats(resourceOptions?: HttpResourceOptions<GetDashboardTimesheetStatsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDashboardTimesheetStatsResponse | undefined>;
    getDashboardTimesheetStats(resourceOptions?: HttpResourceOptions<GetDashboardTimesheetStatsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDashboardTimesheetStatsResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Dashboard/timesheet-stats`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getDashboardInvoicingStats(resourceOptions: HttpResourceOptions<GetDashboardInvoicingStatsResponse, unknown> & { defaultValue: NoInfer<GetDashboardInvoicingStatsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDashboardInvoicingStatsResponse>;
    getDashboardInvoicingStats(resourceOptions?: HttpResourceOptions<GetDashboardInvoicingStatsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDashboardInvoicingStatsResponse | undefined>;
    getDashboardInvoicingStats(resourceOptions?: HttpResourceOptions<GetDashboardInvoicingStatsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDashboardInvoicingStatsResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Dashboard/invoicing-stats`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
